import { useAthleteLessons } from '../api/use-athlete-lessons.js';
import { LessonRow } from '../components/athlete-lesson-row.js';
import { WaitNote } from '../components/wait-note.js';

/**
 * The athlete's My lessons (board "Noa · My lessons", Athlete Portal canvas,
 * approved 16 October): the next lesson in a panel, then what has been, each
 * with the first line of its plan.
 *
 * Nothing here is about anyone else, money or cancelling, and cancelled lessons
 * never arrive (ruled 16 October).
 */
export function MyLessonsRoute() {
  const state = useAthleteLessons();

  if (state.status === 'loading') return <WaitNote className="empty">Checking…</WaitNote>;
  if (state.status === 'failed') return <p className="empty">{state.message}</p>;

  const now = Date.now();
  const coming = state.lessons.filter((lesson) => new Date(lesson.end).getTime() >= now);
  const past = state.lessons.filter((lesson) => new Date(lesson.end).getTime() < now);
  const [next] = coming;

  return (
    <>
      <section className="panel">
        <h2>{next?.is_clinic ? 'Next clinic' : 'Next lesson'}</h2>
        {next ? (
          <LessonRow lesson={next} withPlace />
        ) : (
          <p className="empty">Nothing booked yet.</p>
        )}
      </section>

      {coming.length > 1 ? (
        <>
          <span className="section-label">Coming up</span>
          {coming.slice(1).map((lesson) => (
            <LessonRow key={lesson.lesson_id} lesson={lesson} />
          ))}
        </>
      ) : null}

      {past.length > 0 ? (
        <>
          <span className="section-label">Past lessons</span>
          {past.map((lesson) => (
            <LessonRow key={lesson.lesson_id} lesson={lesson} showOutcome />
          ))}
        </>
      ) : null}
    </>
  );
}
